export const imageMimes = ['image/png', 'image/jpeg', 'image/gif', 'image/webp']
export const audioMimes = ['audio/mpeg', 'audio/mp3', 'audio/wav']